import { useFormikContext } from 'formik';
import { Box, Stack, Typography, Chip, alpha, Avatar } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { TagType } from '../../config/tag';
import { useState } from 'react';
import TagListDialog from '../Tag/TagListDialog';

const TagItemLinks = ({ disabled, tagItemLink }) => {
  const { values, setFieldValue } = useFormikContext();
  const [tagListDialog, setTagListDialog] = useState({ open: false, mode: null });

  const linkedItems = values?.tagItemLink ?? [];

  const labels = linkedItems.filter((item) => item.tagType === TagType.LABEL);
  const stickers = linkedItems.filter((item) => item.tagType === TagType.STICKER);

  const handleSaveTags = (items) => {
    const otherItems = linkedItems.filter((item) => item.tagType !== tagListDialog.mode);

    setFieldValue('tagItemLink', [...otherItems, ...items]);
  };

  return (
    <>
      <Box>
        <Box border="1px solid #e9e8e8" p={1.5} mb={1} borderRadius={1}>
          <Typography fontWeight="bold" mb={1.5}>
            Címkék
          </Typography>
          <Stack direction="row" columnGap={2} rowGap={2} flexWrap="wrap">
            {labels?.map((item) => (
              <Chip
                key={item.id}
                label={item.name}
                sx={{
                  bgcolor: alpha(item.color, 0.2),
                  color: item.color,
                  borderRadius: '5px',
                  fontWeight: 'bold',

                  '&:hover': {
                    bgcolor: disabled ? alpha(item.color, 0.2) : alpha(item.color, 0.3),
                  },
                }}
              />
            ))}
            <Chip
              icon={<AddIcon />}
              label="Címke hozzáadása"
              variant="outlined"
              disabled={disabled}
              onClick={() => setTagListDialog({ open: true, mode: TagType.LABEL })}
              sx={{
                cursor: 'pointer',
                borderRadius: '5px',
                fontWeight: 'bold',
              }}
            />
          </Stack>
        </Box>

        <Box border="1px solid #e9e8e8" p={1.5} borderRadius={1}>
          <Typography fontWeight="bold" mb={1.5}>
            Matricák
          </Typography>
          <Stack direction="row" columnGap={2} rowGap={2} flexWrap="wrap">
            {stickers?.map((item) => (
              <Avatar
                key={item.id}
                sx={{
                  height: 100,
                  width: 100,
                  boxSizing: 'border-box',
                  textAlign: 'center',
                }}
                src={`${process.env.REACT_APP_API_URL}/${item.picture}`}
              >
                {item.name}
              </Avatar>
            ))}
            <Avatar
              onClick={() => {
                if (disabled) return;

                setTagListDialog({ open: true, mode: TagType.STICKER });
              }}
              sx={{
                height: 100,
                width: 100,
                background: 'transparent',
                color: '#000000DE',
                border: '1px solid #bdbdbd',
                cursor: disabled ? 'default' : 'pointer',
                opacity: disabled ? 0.38 : 1,
              }}
            >
              <Stack alignItems="center" justifyContent="center" spacing={0.5} textAlign="center">
                <AddIcon />
                <Typography>Matrica hozzáad.</Typography>
              </Stack>
            </Avatar>
          </Stack>
        </Box>
      </Box>
      <TagListDialog
        dialogData={tagListDialog}
        handleClose={() => setTagListDialog({ open: false, mode: null })}
        allItems={(tagItemLink ?? []).filter((item) => item.tagType === tagListDialog.mode)}
        linkedItems={tagListDialog.mode === TagType.LABEL ? labels : stickers}
        onSave={handleSaveTags}
      />
    </>
  );
};

export default TagItemLinks;
